import { render, staticRenderFns } from "./OGDHLPWN.vue?vue&type=template&id=1fa74b68&scoped=true&"
import script from "./OGDHLPWN.vue?vue&type=script&lang=js&"
export * from "./OGDHLPWN.vue?vue&type=script&lang=js&"
import style0 from "./OGDHLPWN.vue?vue&type=style&index=0&id=1fa74b68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa74b68",
  null
  
)

export default component.exports